import React from 'react';
import logo from '../../../images/logo.png';
import styles from './styles.module.scss';
import classNames from 'classnames';

export function HeaderLogo() {
  return (
    <div className='row'>
      <div className='mb-4 text-left'>
        <img
          src={logo}
          alt='Screenloop'
          className={classNames(styles['header-logo'])}
        />
      </div>
    </div>
  );
}
